/* istanbul ignore file */
import { useEmployeeOfferId, useEmployeeOfferUrl } from 'domain/people/employee/offers/employeeOfferRouting';
import useEmployeeOfferService from 'domain/people/employee/offers/shared/employeeOfferService';
import { SensitiveShowPageLayout } from 'framework/sensitiveData';
import { ShowSection, FieldListLayout, BigSectionRow, SectionRow } from 'framework/ui/layout';
import { OfferCompensationDetailsField } from 'domain/shared/offerCompensation';
import { Show, useShowContext } from 'framework/show';
import EditEmployeeOfferButton from 'domain/people/employee/offers/shared/buttons/EditEmployeeOfferButton';
import { DELETE, UPDATE } from 'domain/shared/core/permissions';
import DeleteEmployeeOfferButton from 'domain/people/employee/offers/shared/buttons/DeleteEmployeeOfferButton';
import { AttachmentsListField } from 'domain/shared/artifact/field';
import { BooleanField, DateField, HtmlField, TextField } from 'framework/ui/field';
import { SOFTWARE_ENGINEER_ID, EmployeePositionField, EmployeeTechnologyField } from 'domain/shared/employee';

const OfferTechnologyField = () => {
  const { data } = useShowContext();
  // eslint-disable-next-line eqeqeq
  const isSoftwareEngineer = data.getValueBySource('positionId') == SOFTWARE_ENGINEER_ID;
  return isSoftwareEngineer ? <EmployeeTechnologyField source="technologyId" label="Technology" /> : null;
};

const ViewEmployeeOfferPage = () => {
  const employeeOfferId = useEmployeeOfferId();
  const { getById } = useEmployeeOfferService();
  const { getListUrl } = useEmployeeOfferUrl();

  return (
    <SensitiveShowPageLayout
      toggleSensitiveDataButtonProps={{ size: 'small' }}
      buttons={[
        <EditEmployeeOfferButton
          key="edit-employee-offer"
          icon={<i className="fa fa-edit" />}
          permissionToCheck={UPDATE}
          size="small"
        />,
        <DeleteEmployeeOfferButton key="delete-employee-offer" permissionToCheck={DELETE} size="small" />,
      ]}
      timerId={getListUrl()}
    >
      <Show getDataMethod={() => getById(employeeOfferId)}>
        <ShowSection title="Offer information">
          <SectionRow>
            <EmployeePositionField source="positionId" label="Position" />
            <OfferTechnologyField />
            <TextField source="competencyLevel" label="Competency level" />
            <TextField source="contractDuration" label="Contract duration" />
            <BooleanField source="isAccepted" label="Offer accepted" />
            <DateField source="createdAt" label="Created at" />
            <DateField source="updatedAt" label="Last modified" />
          </SectionRow>
        </ShowSection>
        <ShowSection title="Offer compensation details">
          <FieldListLayout source="offerCompensations" hasSeparator>
            <OfferCompensationDetailsField />
          </FieldListLayout>
        </ShowSection>
        <BigSectionRow>
          <HtmlField source="additionalInformation" label="Additional information" />
          <AttachmentsListField source="attachmentIds" label="Attachments" />
        </BigSectionRow>
      </Show>
    </SensitiveShowPageLayout>
  );
};

export default ViewEmployeeOfferPage;
